import { investmentHeader, returnOnInvestmentHeader, separator } from '..'
import type { UseAssetFormLayout } from '../../types'
import { currentTotalValueLayout } from '../currentTotalValue'
import { ROILayout } from '../ROI'
import { averagePurchasePriceLayout } from '../averagePurchasePrice'
import { EAssetType } from 'findef'
import { initialValueLayout } from '../initialValue'
import { liabilitiesLayout } from '../liabilities'

export const createStep2Layout = (options: { withRelatedLiabilities?: boolean } = { withRelatedLiabilities: true }): UseAssetFormLayout => {
  return {
    name: 'step2',
    attributes: { class: 'space-y-12' },
    needs: ['asset.type'],
    children: (_state, form) => {
      if (form.state.value.asset.type === EAssetType.CASH) {
        return [
          {
            key: 'investment-information-cash',
            children: [
              investmentHeader,
              {
                attributes: { class: 'grid grid-cols-1 md:grid-cols-2 gap-4' },
                children: [
                  { attributes: { wrapperClass: 'col-span-1' }, render: 'invested' },
                  {
                    attributes: { class: 'grid grid-cols-1 md:grid-cols-2 gap-4' },
                    children: [{ render: 'asset.interest' }, { render: 'time', key: 'timeField' }]
                  },
                  currentTotalValueLayout(),
                  ROILayout()
                ],
                key: 'cash-investment-container'
              },
              separator,
              liabilitiesLayout()
            ]
          }
        ]
      }
      return [
        {
          key: `investment-information-default-${form.state.value.asset.type}`,
          children: [
            investmentHeader,
            {
              attributes: { class: 'grid grid-cols-1 md:grid-cols-2 gap-4' },
              children: [{ render: 'invested' }, { render: 'time', key: 'timeField' }]
            },
            {
              attributes: { class: 'grid grid-cols-1 md:grid-cols-2 gap-4' },
              children: [
                {
                  render:
                    form.state.value.asset.type === EAssetType.REAL_ESTATE ? 'ownershipPercentage' : 'quantity'
                },
                {
                  ...(form.state.value.asset.type === EAssetType.REAL_ESTATE
                    ? initialValueLayout()
                    : averagePurchasePriceLayout())
                }
              ],
              key: 'quantity-container'
            },
            options.withRelatedLiabilities ? separator : null,
            options.withRelatedLiabilities ? liabilitiesLayout() : null
          ]
        },
        {
          key: 'investment-information-default-price-info',
          children: [
            returnOnInvestmentHeader,
            {
              attributes: { class: 'grid grid-cols-1 md:grid-cols-2 gap-4' },
              children: [
                { render: 'asset.ledger.sharePrice' },
                {
                  attributes: { class: 'grid grid-cols-1 md:grid-cols-2 gap-4' },
                  children: [currentTotalValueLayout(), ROILayout()]
                }
              ]
            }
          ]
        }
      ]
    }
  }
}

export const step2Layout: UseAssetFormLayout = createStep2Layout();
